/**
 * PHARMAKON — Cross-module X XWP-26 : journal des achats, browser twin of the server CONFIG.
 *
 * The journal (`pages/achat/JournalAchats.jsx`, refonte WP-52) shows the note preview the server projects on each
 * row (`has_note` / `note_apercu`, XA-04) and re-reads its page when the per-pharmacy hub names one
 * of its rows (topic `achats`, keys `achat:<id>` — 02_DESIGN §2.6, XA-17).
 *
 * Owner of the values: `apps/server/src/config/achat-journal.config.js`. This file is a twin, not an
 * import, because the API image is built from apps/server alone; the server test
 * `src/__tests__/achat-journal.parity.test.js` imports both and fails on any drift — change a value
 * there first, then here.
 */

/** XA-04 — longest note preview served on a journal row (characters, before the ellipsis). */
export const ACHAT_NOTE_APERCU_MAX = 280;

/** XA-04 — appended to a preview cut before the end of the note. */
export const ACHAT_NOTE_ELLIPSE = "…";

/** Targeted invalidation of the purchase views: SSE topic on the per-pharmacy hub. */
export const INVALIDATION_ACHATS = Object.freeze({ sujet: "achats" });

/** The touched key of one facture d'achat (its journal row). */
export const cleAchat = (id) => `achat:${id}`;

// ─── Refonte WP-52 — the two journals (ux/02 §7, §8) — twins of the server CONFIG ─────────────

/** S4 tabs; the server counts each one over the whole filter. */
export const ONGLET_JOURNAL_ACHATS = Object.freeze({
  TOUS: "TOUS",
  BROUILLONS: "BROUILLONS",
  VALIDEES: "VALIDEES",
  A_REGLER: "A_REGLER",
  ECARTS_A_TRAITER: "ECARTS_A_TRAITER",
});

/** S4 « Écart » filter values (OR between them). */
export const FILTRE_ECART_ACHAT = Object.freeze({
  AVEC_ECART: "AVEC_ECART",
  AVOIR_FINANCIER: "AVOIR_FINANCIER",
  MANQUANTS: "MANQUANTS",
});

/** State of the TTC écart of a journal row (ux/02 §2.3). */
export const ETAT_ECART_TTC = Object.freeze({
  NON_SAISI: "NON_SAISI",
  CONFORME: "CONFORME",
  AVOIR_FINANCIER: "AVOIR_FINANCIER",
  INFERIEUR: "INFERIEUR",
});

/** S5 « Regrouper par ». */
export const GROUPEMENT_LIGNES_ACHAT = Object.freeze({
  AUCUN: "AUCUN",
  FOURNISSEUR: "FOURNISSEUR",
  PRODUIT: "PRODUIT",
  FACTURE: "FACTURE",
  LABORATOIRE: "LABORATOIRE",
});

/** S5 pagination (server-side, 50 rows per page). */
export const PAGINATION_LIGNES_ACHAT = Object.freeze({ PAGE: 1, LIMIT: 50, LIMIT_MAX: 200 });
